'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getTrackPayload;
function getTrackPayload(eventKey) {
  var eventProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    eventKey: eventKey,
    eventProperties: eventProperties
  };
}
module.exports = exports['default'];